import { Flex } from "antd";
import { useState } from "react";
import Filters from "../../components/Filters";
import CollectionsTimeLineWrapper from "./CollectionsTimeLineWrapper";
import TableEventsWrapper from "./TableEventsWrapper";

export default function CollectionsChangeRefact() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedZones, setSelectedZones] = useState(["all"]);

  return (
    <Flex
      vertical
      gap={50}
      justify="center"
      align="center"
      style={{ width: "100%", margin: "0 auto" }}>
      <Filters
        page="collections_change"
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedZones={selectedZones}
        setSelectedZones={setSelectedZones}
        filters={["data", "zonas"]}
      />
      <CollectionsTimeLineWrapper
        selectedZones={selectedZones}
        selectedDate={selectedDate}
      />
      {selectedDate && (
        <TableEventsWrapper selectedDate={selectedDate} zones={selectedZones} />
      )}
    </Flex>
  );
}
